import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const ChooseBox = ({ to, children, onClick }) => (
  <Link className="c-select-box" to={to} onClick={onClick}>
    <div className="u-fill-parent u-text-center u-bg-white">
      <div className="o-tableize o-tableize--full o-tableize--fixed o-tableize--middle u-fill-parent">
        <div className="o-tableize__cell u-1/1">
          <div className="c-heading c-heading--huge c-heading--underline-center">
            { children }
          </div>
        </div>
      </div>
    </div>
  </Link>
);
ChooseBox.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};
ChooseBox.defaultProps = {
  to: '',
  onClick: () => true,
};

export default ChooseBox;




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/components/ChooseBox.jsx